webpackJsonp([187670924316574],{

/***/ 1914:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---events-calendar-a0e39f21c11f6a62c5ab.js